export default "__VITE_ASSET__9e30aed7__$_?nuxt_component=async&nuxt_component_name=SvgoFreeneo__"